import glamorous from 'glamorous';

import { media } from '../../styles';

const Footer = glamorous.footer({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',

  height: 56,

  background: '#444',
  color: '#fff',
}, props => ({
  [media('sm', { isMax: true })]: {
    display: props.isViewingEvent ? 'none' : 'flex',
  },
}));

export default Footer;



// WEBPACK FOOTER //
// ./src/components/layout/Footer.js